import { render, staticRenderFns } from "./StoreSellerCreate.vue?vue&type=template&id=2e4924d2"
import script from "./StoreSellerCreate.vue?vue&type=script&lang=js"
export * from "./StoreSellerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports